// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const _3rdpartyByoTwilioUpdateRequestSchema: Array<StaticFieldSchema> = [
  {
    key: 'accountSid',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'accountSid',
  },
  {
    key: 'phoneNumber',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'phoneNumber',
  },
  {
    key: 'apiKey',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'apiKey',
  },
  {
    key: 'secretKey',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'secretKey',
  },
  {
    key: 'authToken',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'authToken',
  },
  {
    key: 'messagingServiceSid',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'messagingServiceSid',
  },
  {
    key: 'conversationServiceSid',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'conversationServiceSid',
  },
  {
    key: 'enabled',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'enabled',
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(_3rdpartyByoTwilioUpdateRequestSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(_3rdpartyByoTwilioUpdateRequestSchema)
}
